import type React from 'react';
import SvgIcon from './SvgIcon';

const DualRotatingArrowSvg: React.FC = ({
  ariaLabel,
}:{
  ariaLabel?: string;
}) => (
  <SvgIcon
    width="16"
    height="22"
    viewBox="0 0 16 22"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-label={ariaLabel}
  >
    <path
      d="M1.77 16.0091C1.81 15.9691 1.84 15.9191 1.88 15.8791L3.19 14.5691C2.42 13.5391 2 12.3091 2 10.9991C2 7.68906 4.69 4.99906 8 4.99906H9.59L8.3 6.28906L9.71 7.69906L12.71 4.69906C13.1 4.30906 13.1 3.67906 12.71 3.28906L9.71 0.289062L8.3 1.69906L9.59 2.99906H8C3.59 2.99906 0 6.58906 0 10.9991C0 12.8491 0.62 14.5991 1.77 16.0091Z"
      fill="currentColor"
      fillOpacity="0.9"
    />
    <path
      d="M14 10.9991C14 14.3091 11.31 16.9991 8 16.9991H6.41L7.7 15.7091L6.29 14.2991L3.29 17.2991C2.9 17.6891 2.9 18.3191 3.29 18.7091L6.29 21.7091L7.7 20.2991L6.41 18.9991H8C12.41 18.9991 16 15.4091 16 10.9991C16 9.14906 15.38 7.39906 14.23 5.98906C14.19 6.02906 14.16 6.07906 14.12 6.11906L12.81 7.42906C13.58 8.45906 14 9.68906 14 10.9991Z"
      fill="currentColor"
      fillOpacity="0.9"
    />
  </SvgIcon>
);

export default DualRotatingArrowSvg;
